import styled from '@emotion/styled';
import React from 'react';
import { EpicValueIcon } from './EpicValueIcon';
import { EpicValueTitle } from './EpicValueTitle';
const EpicValueHeaderContainer = styled.div `
  display: flex;
  flex-flow: row nowrap;
  font-family: Verdana, sans-serif;
  height: 24px;
  position: relative;
  width: 100%;
  overflow: hidden;
`;
const EpicValueHeaderLabel = styled.div `
  align-items: center;
  background-color: rgba(0, 20, 60, 1);
  color: #fff;
  display: flex;
  font-size: 12px;
  line-height: 16px;
  margin-right: 22px;
  padding: 0 10px;
  position: relative;
  white-space: nowrap;
  &::after {
    border-right: 20px solid transparent;
    border-top: 24px solid rgba(0, 20, 60, 1);
    content: '';
    height: 0;
    left: 100%;
    position: absolute;
    top: 0;
    width: 0;
  }
`;
const EpicValueHeaderInfo = styled.div `
  align-items: center;
  background-color: rgba(250, 255, 5, 1);
  color: rgba(0, 20, 60, 1);
  display: flex;
  flex: 1;
  justify-content: right;
  padding-right: 10px;
  position: relative;
  text-align: right;
  &::before {
    border-bottom: 24px solid rgba(250, 255, 5, 1);
    border-left: 20px solid transparent;
    content: '';
    height: 0;
    position: absolute;
    right: 100%;
    top: 0;
    width: 0;
  }
`;
const EpicValueHeaderInfoDate = styled.div `
  font-size: 10px;
  line-height: 24px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
`;
export const EpicValueHeader = (props) => {
    const { concessionType, headerInfoText } = props;
    return (React.createElement(EpicValueHeaderContainer, null,
        React.createElement(EpicValueHeaderLabel, null,
            concessionType && React.createElement(EpicValueIcon, { concession: concessionType }),
            concessionType && React.createElement(EpicValueTitle, { concession: concessionType })),
        React.createElement(EpicValueHeaderInfo, null,
            React.createElement(EpicValueHeaderInfoDate, { "data-testid": "EpicValueHeaderInfoDate" }, headerInfoText))));
};
